const KEY = 'astromatch_onboarding_v1'
const KNOWN_EMAILS_KEY = 'astromatch_known_emails_v1'

export function getOnboarding() {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export function setOnboarding(patch) {
  const current = getOnboarding()
  const next = { ...current, ...patch }
  localStorage.setItem(KEY, JSON.stringify(next))
  return next
}

export function getKnownEmails() {
  try {
    const raw = localStorage.getItem(KNOWN_EMAILS_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function addKnownEmail(email) {
  const normalized = String(email || '').trim().toLowerCase()
  if (!normalized) return
  const existing = getKnownEmails()
  if (existing.includes(normalized)) return
  localStorage.setItem(KNOWN_EMAILS_KEY, JSON.stringify([normalized, ...existing]))
}

